'use strict';

{
    var app = angular.module('tf.nav', [])
        .factory('navSvc', ['$rootScope', '$timeout', '$window', 'userConfig', '$state', '$document', '$localStorage', '$resource', "breakpointObserver", "recentPortfolioService",
            function ($rootScope, $timeout, $window, userConfig, $state, $document, $localStorage, $resource, breakpointObserver, recentPortfolioService) {


            var storage = $localStorage.$default({
                menuType: 'new',
                isFavOpen: true,
                isOtherOpen: true,
                isFirstRun: true,
                hasShownCourse: false
            });

            var FavouritePortfolio = $resource('/tradefloor/api/portfolio/:id/favourite', {id: '@id'}, {
                star: {method: 'PUT'},
                unstar: {method: 'DELETE'}
            });


            function byName(a, b) {
                if (a.accountName < b.accountName)
                    return -1;
                if (a.accountName > b.accountName)
                    return 1;

                return 0;
            }

            var defaultPortfolios = [];
            for (var i = 0; i < userConfig.favourites.length; i++) {
                var fav = userConfig.favourites[i];
                defaultPortfolios.push({
                    id: fav.id,
                    accountName: fav.name,
                    scratch: fav.scratch,
                    favourite: true
                });
            }

            defaultPortfolios.sort(byName);

            // TODO broadcast state change so elements that are calculating their width can resize
            const svc = {
                hasSideMenu: true,
                hasFooter: userConfig.branding === 'TC' ||
                           userConfig.branding === 'GAME' ||
                           userConfig.branding === 'NEWCASTLE' ||
                           userConfig.branding === 'IV' ||
                           userConfig.branding === 'OPEN_MARKETS' ||
                           userConfig.branding === 'OPEN_TRADER' ||
                           userConfig.branding === 'BELLMONT' ||
                           userConfig.branding === 'FUTURE_ASSIST' ||
                           userConfig.branding === 'ALLFIN' ||
                           userConfig.branding === 'SUUBEE' ||
                           // userConfig.branding === 'WAIMAK' ||
                           userConfig.branding === 'LIQUIDITY' ||
                    (userConfig.ordersEnabled && userConfig.branding === 'TF'),
                regularMenu: (storage.menuType == 'new'),
                portfolios: defaultPortfolios,
                openPortfolios: defaultPortfolios.filter(function (p) {
                    return !p.favourite;
                }),
                favouritePortfolios: defaultPortfolios.filter(function (p) {
                    return p.favourite;
                }),
                scratchpads: [],
                activePortfolio: null,
                splitPortfolios: function () {
                    this.openPortfolios = this.portfolios.filter(function (p) {
                        return !p.favourite;
                    });

                    this.favouritePortfolios = this.portfolios.filter(function (p) {
                        return p.favourite;
                    });
                },

                openPortfolio: function (portfolio) {

                    recentPortfolioService.openPortfolio(portfolio);

                    /* Legacy stuff I'm too scared to remove right now */
                    if (!this.portfolios.some(function (element, index, array) {
                            return element.id == portfolio.id;
                        })) {
                        this.portfolios.unshift(portfolio);
                    }
                    this.portfolios.sort(byName);

                    this.splitPortfolios();

                    this.activePortfolio = portfolio;
                },

                star: function (portfolio, addToList) {

                    recentPortfolioService.star(portfolio);

                    /* Legacy stuff I'm too scared to remove right now */
                    var self = this;

                    // FavouritePortfolio.star({id: portfolio.id}).$promise.then(function () {
                    portfolio.favourite = true;

                    var existing = false;
                    self.portfolios.forEach(function (p) {
                        if (p.id == portfolio.id) {
                            p.favourite = true;
                            existing = true;
                        }
                    });

                    if (addToList && !existing) {

                        var newPortfolio = {
                            id: portfolio.id,
                            accountName: portfolio.accountName,
                            favourite: true
                        };

                        self.portfolios.push(newPortfolio);
                        self.portfolios.sort(byName);
                    }
                    self.splitPortfolios();
                    // });
                },

                unstar: function (portfolio, removeFromList) {

                    recentPortfolioService.unstar(portfolio);

                    /* Legacy stuff I'm too scared to remove right now */
                    var self = this;

                    // FavouritePortfolio.unstar({id: portfolio.id}).$promise.then(function () {

                    var existing = false;
                    self.portfolios.forEach(function (p) {
                        if (p.id == portfolio.id) {
                            p.favourite = false;
                            existing = true;
                        }
                    });

                    portfolio.favourite = false;

                    if (removeFromList && existing) {
                        self.portfolios = self.portfolios.filter(function (p) {
                            return p.id != portfolio.id;
                        });

                        if (self.activePortfolio && self.activePortfolio.id == portfolio.id) {
                            self.activePortfolio = null;
                        }
                    }
                    self.splitPortfolios();
                    // });
                },

                toggleStar: function (portfolio, fromOpenAccount) {
                    if (portfolio.favourite) {
                        this.unstar(portfolio, !fromOpenAccount);
                    } else {
                        this.star(portfolio, !fromOpenAccount);
                    }
                },

                isFavourite: function (portfolio) {
                    for (var i = 0; i < this.favouritePortfolios.length; i++) {
                        var p = this.favouritePortfolios[i];
                        if (p.id == portfolio.id && p.favourite) {
                            return true;
                        }
                    }

                    return false;
                }
            };
            return svc;
        }])

        .controller('navCtrl', ['navSvc', '$scope', '$rootScope', '$state', '$uibModal', 'userConfig', '$http', '$window', 'tfStore', 'photoUpload', 'Fullscreen', '$timeout', '$localStorage',
            function navController(navSvc, $scope, $rootScope, $state, $uibModal, userConfig, $http, $window, tfStore, photoUpload, Fullscreen, $timeout, $localStorage) {

            $scope.userConfig = userConfig;
            $scope.$state = $state;
            $scope.navSvc = navSvc;
            $scope.$storage = $localStorage;

            $rootScope.logout = function () {
                return $http.get('/tradefloor/api/logout').then(function (response) {
                    $window.location.href = response.headers('location') || "/";
                });
            };
            }])
}
